const ENV_MAPPING = {
    'google.places_api_key': process.env.MIX_GOOGLE_PLACES_API_KEY || '',
}

export default {
    methods: {
        getConfiguration(key, defaultValue = null) {
            if (Object.keys(window.manual_configuration || {}).includes(key)) {
                return window.manual_configuration[key];
            } else if (Object.keys(ENV_MAPPING).includes(key)) {
                const value = ENV_MAPPING[key];
                return value !== undefined ? value : defaultValue;
            } else {
                throw new Error(`No config key ${key}`);
            }
        },
    }
}